export const SupportStatus = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  RESOLVED: "RESOLVED",
  IN_PROGRESS: "IN_PROGRESS",
} as const;

export type SupportStatus = (typeof SupportStatus)[keyof typeof SupportStatus];

export const SupportPriority = {
  HIGH: "HIGH",
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  URGENT: "URGENT",
} as const;

export type SupportPriority =
  (typeof SupportPriority)[keyof typeof SupportPriority];

export interface SupportTicket {
  id: string;
  category: string;
  subject: string;
  status: SupportStatus;
  priority: SupportPriority;
  images?: string[];
  createdAt: string;
  deletedAt: string;
  updatedAt: string;
  lastReply: string;
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    role: string;
  };
  replies: {
    id: string;
    images: [];
    lastReply: string | null;
    repliedById: string;
    text: string;
    ticketId: string;
    user: {
      id: string;
      email: string;
      firstName: string;
      lastName: string;
      role: string;
    };
    createdAt: string;
    deletedAt: string | null;
    updatedAt: string;
  }[];
}

export interface SupportTicketMeta {
  hasNextPage: boolean;
  hasPrevPage: boolean;
  limit: number;
  page: number;
  total: number;
  totalPages: number;
}

export interface SupportTicketInterface {
  data: SupportTicket[];
  meta: SupportTicketMeta;
}
